document.addEventListener("DOMContentLoaded", () => {
  const productForm = document.querySelector('form[id^="product-form"]');
  if (!productForm) return;

  // Elements
  const priceElement = document.getElementById("live-price");
  const mainPriceElement = document.querySelector('[data-product-price]');
  const perBottleElements = document.querySelectorAll('.per-bottle-price');
  const compareAtElement = document.querySelector('.compare-at-price');
  const unitPriceElement = document.querySelector('[data-product-unit-price]');
  const unitPriceBaseElement = document.querySelector('[data-product-base]');
  const priceOffElement = document.querySelector('[data-price-off]');
  const priceOffAmountElement = document.querySelector('[data-price-off-amount]');
  const addButton = productForm.querySelector('button[type="submit"]');
  const variantInput = productForm.querySelector('input[name="id"]');
  const quantityInput = productForm.querySelector('[name="quantity"]');
  const oneTimeRadio = document.getElementById('one-time');
  const subscriptionRadio = document.getElementById('subscription');
  const planSelect = document.getElementById('selling-plan-select');
  const planDescription = document.querySelector('.plan-description');
  const subscriptionPlans = document.querySelector('.subscription-plans');
  const productPriceRoot = document.querySelector('product-price-root');

  const productData = window.productData || JSON.parse(document.getElementById('product-variants-json')?.textContent || '{}');
  const STORAGE_KEY = `shopify_quantity_${productData.handle || 'default'}`;
  const moneyFormat = window.shopMoneyFormat || '${{amount}}';

  function formatMoney(cents, format = moneyFormat) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    const placeholder = format.match(placeholderRegex)?.[1];
    let value = '';
    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return format.replace(placeholderRegex, value);
  }

  function getQuantity() {
    const qty = parseInt(quantityInput?.value) || 1;
    localStorage.setItem(STORAGE_KEY, qty);
    return qty;
  }

  function setStoredQuantity() {
    const stored = parseInt(localStorage.getItem(STORAGE_KEY)) || 1;
    if (quantityInput && quantityInput.value != stored) {
      quantityInput.value = stored;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function getSelectedVariant() {
    const id = parseInt(variantInput.value);
    return productData.variants.find(v => v.id === id);
  }

  function getUnitPrice(variant) {
    if (!variant) return 0;
    let price = variant.price;

    if (subscriptionRadio?.checked && planSelect?.value) {
      const planId = parseInt(planSelect.value);
      const allocation = variant.selling_plan_allocations?.find(a => a.selling_plan_id === planId);
      if (allocation) {
        price = allocation.price;
      }
    }
    return price;
  }

  function updateProductPriceComponent(variant) {
    if (!variant || !productPriceRoot) return;

    // Update original price
    const originalPriceEl = productPriceRoot.querySelector('.product-price--original');
    if (originalPriceEl) {
      originalPriceEl.innerHTML = formatMoney(variant.price);
    }

    // Update compare-at price
    const comparePriceEl = productPriceRoot.querySelector('.product-price--compare');
    if (comparePriceEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        comparePriceEl.innerHTML = formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = 'inline-block';
      } else {
        comparePriceEl.innerHTML = '';
        comparePriceEl.style.display = 'none';
      }
    }

    // Update unit price
    const unitContainer = productPriceRoot.querySelector('.product-price--unit-container');
    const unitPriceEl = productPriceRoot.querySelector('.product-price--unit-price');
    const refValueEl = productPriceRoot.querySelector('.product-price--reference-value');
    const refUnitEl = productPriceRoot.querySelector('.product-price--reference-unit');

    if (unitContainer) {
      if (variant.unit_price && variant.unit_price_measurement) {
        if (unitPriceEl) {
          unitPriceEl.innerHTML = formatMoney(variant.unit_price);
        }
        
        if (refValueEl && variant.unit_price_measurement.reference_value !== 1) {
          refValueEl.innerHTML = variant.unit_price_measurement.reference_value;
          refValueEl.style.display = '';
        } else if (refValueEl) {
          refValueEl.innerHTML = '';
          refValueEl.style.display = 'none';
        }
        
        if (refUnitEl) {
          refUnitEl.innerHTML = variant.unit_price_measurement.reference_unit;
        }
        
        unitContainer.style.display = 'flex';
      } else {
        unitContainer.style.display = 'none';
      }
    }
  }

  function updatePrice() {
    const variant = getSelectedVariant();
    if (!variant) return;

    const quantity = getQuantity();
    const unitPrice = getUnitPrice(variant);
    const totalPrice = unitPrice * quantity;

    if (mainPriceElement) mainPriceElement.innerHTML = formatMoney(unitPrice);
    if (priceElement) priceElement.innerHTML = formatMoney(totalPrice);

    // Compare-at price
    if (compareAtElement) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareAtElement.textContent = formatMoney(variant.compare_at_price);
        compareAtElement.style.display = '';
      } else {
        compareAtElement.textContent = '';
        compareAtElement.style.display = 'none';
      }
    }

    // Per-bottle/pod price
    if (perBottleElements.length) {
      let podCount = 1;
      const match = variant.title.match(/(\d+)\s*Pack/i);
      if (match) podCount = parseInt(match[1], 10);
      const perPod = unitPrice / podCount;
      perBottleElements.forEach(el => {
        el.textContent = `${formatMoney(perPod)} PER POD`;
      });
    }

    const perPodElement = document.querySelector('.base-price');
    if (perPodElement) {
      let podCount = 1;
      const match = variant.title.match(/(\d+)\s*Pack/i);
      if (match) podCount = parseInt(match[1], 10);
      const perPod = unitPrice;
      perPodElement.textContent = `${formatMoney(perPod)}`;
    }

    const onetimeCompareElement = document.querySelector('.onetime-compare-price');
    if (onetimeCompareElement) {
      // Show crossed-out one-time price only when subscription is selected
      if (subscriptionRadio?.checked) {
        onetimeCompareElement.textContent = formatMoney(variant.price);
        onetimeCompareElement.style.display = '';
      } else {
        onetimeCompareElement.style.display = 'none';
      }
    }

    // Unit price
    if (unitPriceElement && unitPriceBaseElement) {
      const allocation = variant.selling_plan_allocations?.[0];
      const unitPriceCents = variant.unit_price || allocation?.unit_price;
      if (unitPriceCents) {
        unitPriceElement.innerHTML = formatMoney(unitPriceCents);
        unitPriceElement.parentElement.style.display = '';
      } else {
        unitPriceElement.parentElement.style.display = 'none';
      }

      const base = variant.unit_price_measurement;
      if (base && base.reference_unit) {
        let refText = base.reference_value && base.reference_value !== 1 ? `${base.reference_value} ` : '';
        unitPriceBaseElement.innerHTML = `${refText}${base.reference_unit}`;
      }
    }

    // Discount amount
    if (priceOffElement && priceOffAmountElement) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const savings = variant.compare_at_price - variant.price;
        priceOffAmountElement.innerHTML = formatMoney(savings);
        priceOffElement.classList.remove('hide');
      } else {
        priceOffAmountElement.innerHTML = '';
        priceOffElement.classList.add('hide');
      }
    }

    // Add to cart button state
    if (addButton) {
      addButton.disabled = !variant.available;
      const label = addButton.querySelector('.add-to-cart-label, span:first-child');
      if (label) {
        label.textContent = variant.available ? 'ADD TO CART - ' : 'SOLD OUT';
      }
    }

    // Update product-price-root component
    updateProductPriceComponent(variant);
  }

  function setupQuantityButtons() {
    const minus = productForm.querySelector('.quantity-btn[name="minus"]');
    const plus = productForm.querySelector('.quantity-btn[name="plus"]');
    if (!quantityInput || !minus || !plus) return;

    minus.addEventListener('click', () => {
      let val = parseInt(quantityInput.value) || 1;
      if (val > 1) quantityInput.value = val - 1;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    plus.addEventListener('click', () => {
      let val = parseInt(quantityInput.value) || 1;
      quantityInput.value = val + 1;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function setupEventListeners() {
    // Listen for variant radio changes
    const variantRadios = document.querySelectorAll('input.variant-radio, input[name="Select Your Pakcs"], input[name="Select Your Packs"]');
    
    variantRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        const variantId = radio.getAttribute('data-variant-id');
        if (variantId && variantInput) {
          variantInput.value = variantId;
          
          // Use setTimeout to ensure DOM has updated before calling updatePrice
          setTimeout(() => {
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('variant:change', {
              detail: { variant: getSelectedVariant() }
            }));
            updatePrice();
          }, 0);
        }
      });
    });

    // Quantity input
    quantityInput?.addEventListener('change', () => {
      getQuantity();
      updatePrice();
    });

    // Purchase type
    oneTimeRadio?.addEventListener('change', () => {
      subscriptionPlans.style.display = 'none';
      if (planDescription) planDescription.textContent = 'One-time purchase';
      
      if (planSelect) {
        planSelect.disabled = true;
      }
      
      updatePrice();
    });

    subscriptionRadio?.addEventListener('change', () => {
      subscriptionPlans.style.display = 'block';
      
      if (planSelect) {
        planSelect.disabled = false;
        
        if (planSelect.selectedIndex < 0) {
          planSelect.selectedIndex = 0;
        }
        
        const opt = planSelect.options[planSelect.selectedIndex];
        if (opt && planDescription) {
          const freq = opt.dataset.frequency;
          const interval = opt.dataset.interval;
          planDescription.textContent = `Delivered every ${freq} ${interval}${Number(freq) > 1 ? 's' : ''}`;
        }
      }
      
      updatePrice();
    });

    // Plan select
    planSelect?.addEventListener('change', () => {
      const selectedOption = planSelect.options[planSelect.selectedIndex];
      if (selectedOption) {
        const freq = selectedOption.dataset.frequency;
        const interval = selectedOption.dataset.interval;
        planDescription.textContent = `Delivered every ${freq} ${interval}${freq > 1 ? 's' : ''}`;
      }
      updatePrice();
    });

    // On variant change elsewhere
    document.addEventListener('variant:change', updatePrice);
  }

  // Initialize
  setStoredQuantity();
  setupQuantityButtons();
  setupEventListeners();
  updatePrice();
});